import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressIndicator", "connectionStatusContainer",
    "countOfMessagesSentLast24Hours", "countOfPendingMessages",
    "reconnectLink"]

  static values = {
    emailAccountId: Number,
    currentUserId: Number,
    emailAccountOwnerId: Number,
    emailAccountOwnerEmail: String
  }

  connect() {
    this._updateInfo(this.emailAccountIdValue)
  }

  _updateInfo(emailAccountId) {
    var _this = this

    fetch(`/email_accounts/${emailAccountId}`, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(response => {
        _this.progressIndicatorTarget.innerHTML = ""
        _this.countOfMessagesSentLast24HoursTarget.innerHTML = response.sent_in_current_daily_limit
        _this.countOfPendingMessagesTarget.innerHTML = response.pending_messages

        if (response.connected === false || response.authorized === false) {
          let tooltipMessage = ""

          if (response.connected === false) {
            tooltipMessage = i18n.t("js.back.campaigns.settings.connection_has_expired")
          } else {
            tooltipMessage = i18n.t("js.back.campaigns.settings.additional_permissions_required")
          }

          if (this.currentUserIdValue === this.emailAccountOwnerIdValue) {
            tooltipMessage += " " + i18n.t("js.back.campaigns.settings.please_reconnect")
          } else {
            tooltipMessage += " " + i18n.t("js.back.campaigns.settings.ask_owner_to_reconnect", { email: _this.emailAccountOwnerEmailValue })
          }

          if (response.connected === false) {
            _this.connectionStatusContainerTarget.innerHTML = `<span class="tag tag--warning" data-controller="tooltip" data-bs-placement="top" title="${tooltipMessage}">
                                                              <span class="tag__label"><i class="tag__icon far fa-exclamation-triangle" aria-hidden="true"></i>
                                                              ${i18n.t("js.back.campaigns.settings.disconnected")}</span></span>`
          } else {
            _this.connectionStatusContainerTarget.innerHTML = `<span class="tag tag--warning" data-controller="tooltip" data-bs-placement="top" title="${tooltipMessage}">
                                                              <span class="tag__label"><i class="tag__icon far fa-exclamation-triangle" aria-hidden="true"></i>
                                                              ${i18n.t("js.back.campaigns.settings.permissions_required")}</span></span>`
          }

          if (this.currentUserIdValue === this.emailAccountOwnerIdValue && this.hasReconnectLinkTarget) {
            let reconnectUrl, turboMethodAttr
            if (response.provider === "smtp_imap") {
              reconnectUrl = `/connected-apps/smtp_imap/${emailAccountId}/reconnect`
              turboMethodAttr = 'data-turbo-method="post"'
            } else {
              reconnectUrl = `/auth/${response.provider}?redirect_url=%2Fcampaigns%2Fsettings`
              turboMethodAttr = ''
            }
            _this.reconnectLinkTarget.innerHTML = `<a class="h-button h-button--xs" data-controller="loading" data-loading-target="element" data-loading-text-value="${i18n.t("js.reconnecting")}" data-action="loading#show" href="${reconnectUrl}" data-turbo-frame="_top" ${turboMethodAttr}>${i18n.t("js.back.campaigns.settings.reconnect")}</a>&nbsp;&nbsp;`
          }
        } else {
          _this.connectionStatusContainerTarget.innerHTML = `<span class="tag tag--success"><span class="tag__label"><i class="tag__icon far fa-check" aria-hidden="true"></i>${i18n.t("js.back.campaigns.settings.connected")}</span></span>`
        }
      })
  }
}
